import gql from 'graphql-tag';

export const FRAGMENT_EMBED = gql`
  fragment embed on ContentSnippetEmbedType {
    code
    title
    embedType: type
  }
`;
